import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClaimDetailComponent } from './claim/claim-detail/claim-detail.component';
import { ClaimExportComponent } from './claim/claim-export/claim-export.component';
import { ExportGuardService } from './claim/claim-export/guard/export-guard.service';
import { ClaimListComponent } from './claim/claim-list/claim-list.component';
import { SearchListComponent } from './saved-search/search-list/search-list.component';
import { UserDetailsResolver } from './user/resolvers/user-details.resolver';
import { LossStatusesResolver } from './claim/claim-list/resolvers/loss-statuses.resolver';
import { SearchOperatorsResolver } from './claim/claim-list/resolvers/search-operators.resolver';
import { ClaimDataSourcesResolver } from './claim/claim-list/resolvers/claim-data-sources.resolver';
import { EventReportComponent } from './report/event-report/event-report.component';

const appRoutes: Routes = [
  {
    path: 'claim/search',
    canActivateChild: [],
    resolve: [UserDetailsResolver, ClaimDataSourcesResolver],
    data: { title: 'Claim Search', icon: 'fa fa-fw fa-search' },
        children: [
          {
            path: '',
            component: ClaimListComponent,
            pathMatch: 'full',
            canDeactivate: [],
            resolve: [ LossStatusesResolver, SearchOperatorsResolver ]
          },
          {
            path: 'retrieve-search',
            component: SearchListComponent,
            canDeactivate: [],
            data: { title: 'Saved Searches', excludeFromMenu: true }
          },
          {
            path: 'export',
            component: ClaimExportComponent,
            canActivate: [ ExportGuardService ],
            data: { title: 'Claim Export', excludeFromMenu: true }
          },
          {
            path: ':id/report',
            component: EventReportComponent,
            canDeactivate: [],
            data: { title: 'Report Generation', excludeFromMenu: true }
          },
          {
            path: ':source/:id',
            component: ClaimDetailComponent,
            canDeactivate: [],
            data: { title: 'Claim Detail', excludeFromMenu: true }
          },
          {
            path: ':id',
            component: ClaimDetailComponent,
            canDeactivate: [],
            data: { title: 'Claim Detail', excludeFromMenu: true }
          }
        ]
  },
  { path: '**', redirectTo: '/claim/search' }
];


@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
    // , { enableTracing: true } ) // <-- debugging purposes only

  ],
  exports: [
    RouterModule
  ],
  providers: [
  ]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/app-routing.module.ts